export enum ArticleMode {
  WATCH = "watch",
  EDIT = "edit",
}
